export default import.meta.ROLLUP_FILE_URL_yr3lJGjVz1eXEc6pPXRFTQ